import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import {
  fetchTenantConfiguration,
  fetchTenantConfigurationSuccess,
  fetchTenantConfigurationError,
  // setInitialLocation,
  fetchTheme,
  fetchThemeSuccess,
  fetchThemeError,
} from '../reducer';
import * as R from 'ramda';
import { getDecodedAccessToken } from '../../utils/state';
import { LOGIN_SUCCESS } from '../../pages/login/Login.state';
const doTenantConfigurationHTTPCall = async (
  // app,
  client_slug,
  configMetaEndpoint,
  // configSettingsEndpoint,
  // configPaymentsEndpoint
) => {
  const url = `${configMetaEndpoint}/${client_slug}/pos/meta.json`;
  // let settingsUrl = '';
  // let paymentUrl = '';
  // settingsUrl = `${configSettingsEndpoint}/${slug}/${app}/settings.json`;
  // paymentUrl = `${configPaymentsEndpoint}/${slug}/${app}/config.json`;

  const metaResponse = await fetch(url, { cache: 'no-store' });
  const metaData = await metaResponse.json();

  // const settingsResponse = await fetch(settingsUrl, { cache: 'no-store' });
  // const settingsData = await settingsResponse.json();

  // // only one subclient for now
  // const subClients = settingsData?.subClients ?? [''];
  // const subClientPath = Object.keys(subClients[0])[0] || '';
  // const subClientSlug = Object.values(subClients[0])[0] || '';

  // const paymentResponse = await fetch(paymentUrl, { cache: 'no-store' });
  // const paymentData = await paymentResponse.json();

  if (metaResponse.errors) {
    throw new Error(`Frontend config service meta request error`);
  }

  // if (settingsResponse.errors) {
  //   throw new Error(`Frontend config service settings request error`);
  // }

  // if (paymentResponse.errors) {
  //   throw new Error(`Backend config service payment request error`);
  // }

  // Make sure useFakeData is false, unless it is specified as true in settings.json
  // const modifiedSettingsData = {
  //   useFakeData: false,
  //   ...settingsData,
  // };

  return {
    meta: metaData,
    // settings: modifiedSettingsData,
    // subClientPath,
    // subClientSlug,
    // payment: paymentData,
  };
};

/**
 * Upon initializing this epic we do three things:
 * 1. Set the tenant slug in the state
 * 2. Inform the state that we are fetching tenant config
 * 3. Do the tenant config call
 */
export const initializeTenantEpic = (action$, state$) =>
  action$.ofType(LOGIN_SUCCESS).pipe(
    RxOp.flatMap(() => {
      const { client_slug } = getDecodedAccessToken();
      const { configMetaEndpoint } = state$.value.config;
      return Rx.merge(
        Rx.of(fetchTenantConfiguration()),
        Rx.from(
          doTenantConfigurationHTTPCall(client_slug, configMetaEndpoint),
        ).pipe(
          RxOp.map((response) => fetchTenantConfigurationSuccess(response)),
          RxOp.catchError((error) => {
            return Rx.of(
              fetchTenantConfigurationError(
                R.pathOr(error.message, ['response', 'statusText'], error),
              ),
            );
          }),
        ),
      );
    }),
  );

const fetchThemeFromConfigService = async (state) => {
  const { configThemesEndpoint } = state.config;
  const url = `${configThemesEndpoint}/pos/theme.json`;
  const response = await fetch(url, { cache: 'no-store' });

  return response;
};

/* This code fetches our newer flat file themes.
 * The other theme approach will be deprecated.
 */
export const fetchThemeEpic = (_action$, state$) =>
  Rx.merge(
    Rx.of(fetchTheme()),
    Rx.from(fetchThemeFromConfigService(state$.value)).pipe(
      RxOp.mergeMap((response) => Rx.from(response.json())),
      RxOp.map((body) => fetchThemeSuccess(body)),
      RxOp.catchError((error) => Rx.of(fetchThemeError(error))),
    ),
  );
